export const SUBSCRIBE_STATUS = {
  using: '사용중',
  holding: '홀딩중',
  endingSoon: '종료예정',
  bonus: '보너스',
  lumpSum: '일괄결제',
  waiting: '대기중',
  ended: '사용종료',
} as const

export const ACTIVE_PLAN_SUBSCRIBE_STATUSES: readonly string[] = [
  SUBSCRIBE_STATUS.using,
  SUBSCRIBE_STATUS.holding,
  SUBSCRIBE_STATUS.endingSoon,
] as const

export const INACTIVE_PLAN_SUBSCRIBE_STATUSES: readonly string[] = [
  SUBSCRIBE_STATUS.bonus,
  SUBSCRIBE_STATUS.lumpSum,
  SUBSCRIBE_STATUS.waiting,
] as const

export const EXTEND_ACTIVE_SUBSCRIBE_STATUSES: readonly string[] = [
  SUBSCRIBE_STATUS.using,
  SUBSCRIBE_STATUS.holding,
  SUBSCRIBE_STATUS.endingSoon,
  SUBSCRIBE_STATUS.waiting,
] as const
